import _ from 'lodash';
import { refillTypesList } from '../RefillType/constants';
import { getRefillTypeList } from '../RefillType/helper';

export const getNextRefillType = (form, providerForm, config) => {
  if (form) {
    const { mode } = form;
    if (mode === 1) {
      const typesList = getRefillTypeList(form, providerForm, config);
      if (typesList && _.isArray(typesList)) {
        return typesList[0].value;
      }
      return refillTypesList[2].value;
    }
    if (refillTypesList[3]) {
      return refillTypesList[3].value;
    }
  }
  return new Error(`not found form - ${typeof form}`)
};
